const messages = {
  en: {
    translations: {
      header: {
        home: "Home",
        about: "About",
        skills: "Skills",
        services: "Services",
        portfolio: "Portfolio",
        contact: "Contact",
      },
      home: {
        lg: "Idioma",
        pt: "Português",
        en: "Inglês",
      },
      data: {
        description:
          "I'm creative dev front end. I live Joinville-SC, Brazil, and I'm very passionate and dedicated to my work. Currently studying ReactJs and React native.",
        button: "Say hello",
      },
      scroll: {
        down: "Scroll down",
      },
      about: {
        title: "About me",
        subtitle: "My introduction",
        description:
          "Frontend developer. I create web pages with UI/UX user interface, have less a year time of experience but I have study every day inorder to grow to my profissional.",
      },
      info: {
        title1: "Experience",
        title2: "Completed",
        title3: "Available",
        subtitle1: "1 year of study",
        subtitle2: "+ 13 projects",
        subtitle3: "Home office",
      },
      skills: {
        title: "Skills",
        subtitle: "My technical level",
      },
      front: {
        title: "Frontend developer",
        level: "intermediate",
      },
      back: {
        title: "Backend Developer",
        level: "Basic",
      },
      services: {
        title: "Services",
        subtitle: "What i offer",
        view: "View more",
        description:
          "Service a one year of experience. Providing quality work to clients and companies.",
        info1: "I develop the user interface.",
        info2: "Web page development.",
        info3: "Create UX element interactions.",
        info4: "Position your company brand.",
        info5: "Design and Mockups of products for companies.",
        view2: "View more",
        description2:
          "Service a one year of experience. Providing quality work to clients and companies.",
        info6: "I develop the user interface.",
        info7: "Web page development.",
        info8: "Create UX element interactions.",
        info9: "Position your company brand.",
        info10: "Design and Mockups of products for companies.",
      },
      quali: {
        title: "Qualification",
        subtitle: "My personel journey",
        data1: "2022 - Present",
        data2: "October - 2022",
        data3: "August - 2022",
        title2: "Postgraduate",
        subtitle2: "Engineering Fire Fighting Prevention - Unyaleya",
      },
      contact: {
        title: "Get in touch",
        subtitle: "Contact me",
        title2: "Talk to me",
        write: "Write me",
        profile: "My profile",
        title3: "Write your project",
        name: "Name",
        placeName: "Insert your name",
        placeEmail: "Insert your e-mail",
        project: "Project",
        placeProject: "Write your project...",
        button: "Send message",
      },
      footer: {
        copy: "All rigths reserved.",
      },
    },
  },
};

export { messages };
